import {IFetchContext} from "@pg-mono/data-fetcher";
import {IVendorDetailActiveOffersParams} from "@pg-mono/rp-routes/src/types/IVendorDetailActiveOffersParams";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {offerUrlConstants} from "../../offer/helpers/friendly_offer_list/offer_url_constants";
import {OfferType} from "../../offer/types/OfferType";
import {IAppDispatch, IRootState} from "../../store/store";
import {getVendorDetailAllOffers} from "../api/get_vendor_detail_all_offers";
import {getVendorDetailOfferListMap} from "../api/get_vendor_detail_offer_list_map";
import {getVendorDetailOffers} from "../api/get_vendor_detail_offers";
import {initVendorDetailFilters} from "../state/vendor_offer_list_slice";
import {
    buildVendorDetailAllOffersParams,
    buildVendorDetailInactiveOffersParams,
    buildVendorDetailOfferListMapParams,
    buildVendorDetailSoldOffersParams
} from "../utils/vendor_detail_offers_query_params";

export const vendorOfferDetailViewAction =
    (ctx: IFetchContext<IRPRequestMeta, IVendorDetailActiveOffersParams>) => async (dispatch: IAppDispatch, getState: () => IRootState) => {
        const {vendorId} = ctx.match.params;
        const {lokalizacja, typ} = ctx.route.query as {lokalizacja?: string; typ?: string};
        const locationSlug = lokalizacja ?? null;
        const offerType = typ ? (offerUrlConstants.types[typ] as OfferType) : null;

        const cities = getState().vendor.detail.cities;

        let region: number | null = null;
        if (locationSlug && cities) {
            const foundCity = cities.find((city) => city.slug === locationSlug);
            if (foundCity) {
                region = foundCity.id;
            }
        }

        dispatch(initVendorDetailFilters({region, offerType}));

        const parsedVendorId = parseInt(vendorId);

        await dispatch(
            getVendorDetailAllOffers.endpoints.getVendorDetailAllOffers.initiate(buildVendorDetailAllOffersParams({vendorId: parsedVendorId, region}))
        );
        await dispatch(
            getVendorDetailOfferListMap.endpoints.getVendorDetailOfferListMap.initiate(buildVendorDetailOfferListMapParams({vendorId: parsedVendorId, region}))
        );
        await dispatch(
            getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(buildVendorDetailSoldOffersParams({vendorId: parsedVendorId, region, page: 1}))
        );
        await dispatch(
            getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(buildVendorDetailInactiveOffersParams({vendorId: parsedVendorId, region, page: 1}))
        );

        await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
    };
import {IFetchContext} from "@pg-mono/data-fetcher";
import {IVendorDetailActiveOffersParams} from "@pg-mono/rp-routes/src/types/IVendorDetailActiveOffersParams";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {offerUrlConstants} from "../../offer/helpers/friendly_offer_list/offer_url_constants";
import {OfferType} from "../../offer/types/OfferType";
import {IAppDispatch, IRootState} from "../../store/store";
import {getVendorDetailAllOffers} from "../api/get_vendor_detail_all_offers";
import {getVendorDetailOfferListMap} from "../api/get_vendor_detail_offer_list_map";
import {getVendorDetailOffers} from "../api/get_vendor_detail_offers";
import {initVendorDetailFilters} from "../state/vendor_offer_list_slice";
import {
    buildVendorDetailAllOffersParams,
    buildVendorDetailInactiveOffersParams,
    buildVendorDetailOfferListMapParams,
    buildVendorDetailSoldOffersParams
} from "../utils/vendor_detail_offers_query_params";

export const vendorOfferDetailViewAction =
    (ctx: IFetchContext<IRPRequestMeta, IVendorDetailActiveOffersParams>) => async (dispatch: IAppDispatch, getState: () => IRootState) => {
        const {vendorId} = ctx.match.params;
        const {lokalizacja, typ} = ctx.route.query as {lokalizacja?: string; typ?: string};
        const locationSlug = lokalizacja ?? null;
        const offerType = typ ? (offerUrlConstants.types[typ] as OfferType) : null;

        const cities = getState().vendor.detail.cities;

        let region: number | null = null;
        if (locationSlug && cities) {
            const foundCity = cities.find((city) => city.slug === locationSlug);
            if (foundCity) {
                region = foundCity.id;
            }
        }

        dispatch(initVendorDetailFilters({region, offerType}));

        const parsedVendorId = parseInt(vendorId);

        await dispatch(
            getVendorDetailAllOffers.endpoints.getVendorDetailAllOffers.initiate(buildVendorDetailAllOffersParams({vendorId: parsedVendorId, region}))
        );
        await dispatch(
            getVendorDetailOfferListMap.endpoints.getVendorDetailOfferListMap.initiate(buildVendorDetailOfferListMapParams({vendorId: parsedVendorId, region}))
        );
        await dispatch(
            getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(buildVendorDetailSoldOffersParams({vendorId: parsedVendorId, region, page: 1}))
        );
        await dispatch(
            getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(buildVendorDetailInactiveOffersParams({vendorId: parsedVendorId, region, page: 1}))
        );

        await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
    };
